import i18n, { type InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '@/locales/en.json';

const options: InitOptions = {
  resources: {
    en: {
      translation: en as any,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
};

void i18n.use(initReactI18next).init(options);

export default i18n;
